export default "__VITE_ASSET__a679c064__"